import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { SITE_STATUS, useSettings } from "../contextapi/SettingsContext";
import SiteStatusPage from "../web-pages/SiteStatusPage";

/**
 * Blocks the app when site_status is MAINTENANCE or DOWN.
 * Admins (role A) on /admin* routes bypass the gate so they can restore ACTIVE.
 */
const SiteStatusGate = ({ children }) => {
  const { siteStatus, loading } = useSettings();
  const { role } = useSelector((state) => state.auth);
  const location = useLocation();

  const isAdminBypass =
    role === "A" && location.pathname.startsWith("/admin");

  if (loading || siteStatus === SITE_STATUS.ACTIVE || isAdminBypass) {
    return children;
  }

  if (
    siteStatus === SITE_STATUS.MAINTENANCE ||
    siteStatus === SITE_STATUS.DOWN
  ) {
    return <SiteStatusPage status={siteStatus} />;
  }

  return children;
};

SiteStatusGate.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SiteStatusGate;
